/** Matches Phase 3 cleanup and admin-marked deprecated master rows. */
export function isMasterRecordDeprecated(row: {
  name?: string;
  description?: string;
  metadata?: Record<string, unknown>;
}): boolean {
  const name = String(row.name || '').trim();
  const desc = String(row.description || '').trim();
  if (/\[deprecated\]/i.test(name) || /^\[deprecated\]/i.test(desc)) return true;
  return row.metadata?.deprecated === true || row.metadata?.deprecated === 'true';
}

export function resolveMasterRecordActive(row: {
  isActive?: boolean;
  name?: string;
  description?: string;
  metadata?: Record<string, unknown>;
}): boolean {
  if (isMasterRecordDeprecated(row)) return false;
  if (row.isActive === false) return false;
  const metaStatus = String(row.metadata?.status ?? '').trim().toLowerCase();
  if (metaStatus === 'inactive') return false;
  if (metaStatus === 'active') return true;
  return row.isActive !== false;
}

export function isMasterRecordSelectable(row: {
  isActive?: boolean;
  name?: string;
  description?: string;
  metadata?: Record<string, unknown>;
}): boolean {
  return resolveMasterRecordActive(row);
}
